import { useSelector, shallowEqual } from 'react-redux'
import { Button, Hidden } from '@leroy-merlin-br/backyard-react-ui'
import { ChevronRight } from '@leroy-merlin-br/backyard-react-icons'

import { ContextVisibility } from 'reactShared/components/ContextVisibility'

import * as S from './styled'

const Header = ({ regionName }) => {
  const region = useSelector(state => state.cart.region, shallowEqual)

  return (
    <S.HeaderWrapper>
      <div>
        <S.HeaderTitle>Meu carrinho</S.HeaderTitle>
        <ContextVisibility when={['ecommerce']}>
          <Hidden untilKilo kilo>
            <S.Subtitle>
              Sua localização é {region.name || regionName}, você pode retirar
              seus produto nas Lojas da região.{' '}
              <a href="/institucional/politica-de-entrega">
                Política de entrega.
              </a>
            </S.Subtitle>
          </Hidden>
        </ContextVisibility>
      </div>
      <Button variant="outline" href="/" iconRight={ChevronRight}>
        Comprar mais produtos
      </Button>
    </S.HeaderWrapper>
  )
}

export default Header
